import type { ResidentAppPageCopy } from './types';

/**
 * IP4CMS member portal — community/CMS voice (not golf-estate defaults).
 */
export const IP4CMS_PAGE_COPY: ResidentAppPageCopy = {
  home: {
    /** Shown under the member name when no property estate is linked. */
    defaultEstateLine: 'Your community',
  },
};
